import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import $ from "jquery";
import invert from "lodash/invert";
import {injectIntl} from "react-intl";
import {hashHistory} from "react-router";

// import {FormattedMessage} from "react-intl";
import {setActiveQuoteIndex, setQuotes} from "../../actions/roomsFunctions";
import {getCurrentLayout} from "../appLayout";
import {
  canShowSqftButton,
  getRoomName,
} from "../../misc/helpers";
import goToMaterialPage from "../common/goToMaterialPage";
import ActionTypes from "../../misc/actionTypes"
import {clearCart, restoreCart, setCameFromPage} from "../../actions/actionFunctions";
import LayoutNavigationItem from "../visComponents/layoutNavigationItem";
import {checkIfNeedToSetNewCategory} from "../../misc/categorySwitchingFunctions";
import {setNewActiveQuote, updateCurrentQuote} from "../../misc/quotesFunctions";
import {updateAllWizardValues} from "../../actions/wizardFunctions";

const Quote = (props) => {

  const {quotes, quote, quoteIndex, activeQuoteIndex, setActiveQuoteIndex, cartItems, intl, fabricatorData, setCameFromPage,
    updateAllWizardValues, wizardIsActive, allWizardsValues} = props;
  // console.log("quote", quote);

  const quoteClick = async () => {
    if (quoteIndex !== activeQuoteIndex) {
      await updateCurrentQuote();
      setActiveQuoteIndex(quoteIndex);
      await setNewActiveQuote(quoteIndex, quotes);
      checkIfNeedToSetNewCategory(quoteIndex);
    }
  };

  const quoteDeleteClick = async (e) => {
    e.preventDefault();
    e.stopPropagation(); // remove quoteClick!
    quotes.splice(activeQuoteIndex, 1);
    updateAllQutoesTiedItems(quotes);
    if (activeQuoteIndex) { // if we delete 0 (first) quote - let it stay the first active
      setActiveQuoteIndex(activeQuoteIndex - 1);
    }
    await setNewActiveQuote(activeQuoteIndex ? activeQuoteIndex - 1 : 0, quotes);
    props.setQuotes([...quotes]);
    $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS);
  };

  const updateAllQutoesTiedItems = (quotes) => {
    const {cartItems, clearCart, restoreCart} = props;
    let newCartItems = cartItems
      .filter(cartItem => cartItem.currentQuote !== activeQuoteIndex)
      .map(cartItem => {
        if (cartItem.currentQuote > activeQuoteIndex) {
          cartItem.cartFeature.notesList[cartItem.currentQuote - 1] = cartItem.cartFeature.notesList[cartItem.currentQuote]; // change cart notes
          cartItem.currentQuote = cartItem.currentQuote - 1;  // change cart item quote
        }
        return cartItem
      });
    let changedCartFeatures = [];
    newCartItems.forEach(cartItem => {
      if (!changedCartFeatures.includes(cartItem.cartFeature.dbFeature.id)) { // remove last known not if it exist
        delete cartItem.cartFeature.notesList[quotes.length];
        changedCartFeatures.push(cartItem.cartFeature.dbFeature.id);
      }
    })
    clearCart();
    restoreCart({cartItems: newCartItems});
    if (wizardIsActive && allWizardsValues.length) {
      let newAllValues = allWizardsValues
        .filter(selectedObject => selectedObject.quoteIndex !== activeQuoteIndex)
        .map(selectedObject => {
          if (selectedObject.quoteIndex > activeQuoteIndex) {
            selectedObject.quoteIndex = selectedObject.quoteIndex - 1;  // change cart item quote
          }
          return selectedObject
        });
      updateAllWizardValues(newAllValues);
    }
  };

  const quoteEditClick = (e) => {
    e.preventDefault();
    e.stopPropagation(); // remove quoteClick!
    if (checkIfNeedToSetNewCategory(activeQuoteIndex)) {
      goToMaterialPage("shoppingcart", false);
      return
    }
    goToMaterialPage("shoppingcart", true);
  };

  const quoteCalcClick = (e) => {
    e.preventDefault();
    e.stopPropagation(); // remove quoteClick!
    setCameFromPage("shoppingcart");
    hashHistory.push("sqft");
  };

  const isActive = quoteIndex === activeQuoteIndex;

  const layout = getCurrentLayout(quote.room);
  let bgImageUrl = quote.staticCanvasImage || quote.bvImage;
  let layoutName = "";
  const layoutType = Number.isInteger(quote.layoutType) ? quote.layoutType : layout.type;
  if (Number.isInteger(layoutType) && !bgImageUrl) {
    layoutName = invert(layout.layoutTypes)[layoutType];
  }
  const styles = {
    backgroundImage: `url(${bgImageUrl})`
  }

  const severalQuotes = quotes.length > 1;

  const showEditButtons = (isActive && severalQuotes) || !severalQuotes;

  return (
    <li className={"quotes-list__item" + (isActive ? " quotes-list__item--active" : "")}
        onClick={quoteClick} style={styles}>
      {severalQuotes ? (
        <h4 className="quotes-list__item-name">
          {getRoomName(quoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData)}
        </h4>
      ) : null}
      {layoutName && !bgImageUrl ? <LayoutNavigationItem layout={layout} keyType={layoutName} imageOnly={true}/> : null}
      {showEditButtons ? (
        <button className="quotes-list__item-edit ui-edit" onClick={quoteEditClick}/>
      ) : null}
      {showEditButtons && canShowSqftButton()
        ? <button className="quotes-list__item-calc ui-calc" onClick={quoteCalcClick}/>
        : null}
      {isActive && severalQuotes ? (
        <button className="quotes-list__item-delete ui-delete" onClick={quoteDeleteClick}/>
      ) : null}
    </li>
  )
};

Quote.propTypes = {
  quote: PropTypes.object,
  quoteIndex: PropTypes.number,
}

const mapStateToProps = (store) => {
  const {allWizardsValues, wizardIsActive} = store.wizardState;
  return {
    windowWidth: store.serverState.windowWidth,
    quotes: store.quotesState.quotes,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    cartItems: store.cartState.cartItems,
    fabricatorData: store.fabricatorState,
    wizardIsActive,
    allWizardsValues,
  };
};

const mapDispatchToProps = {
  setActiveQuoteIndex,
  setQuotes,
  clearCart,
  restoreCart,
  setCameFromPage,
  updateAllWizardValues,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(Quote)
)
